require('./incident-detecte.scss');

import DemandeActions from '../../../../actions/demande.actions';
import { STEPS } from '../../../../utils/routes.util';

export default class IncidentDetecteComponent {
  constructor() {
    this.controller = IncidentDetecteController;
    this.template = require('./incident-detecte.html');
  }
}

// @ngInject
class IncidentDetecteController {

  constructor($scope, $ngRedux) {
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.INCIDENT_DETECTE));
    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.incidentDetecte ? state.demande.data.incidentDetecte.asMutable({deep: true}) : this.data
        };
      }
    )(this);

    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
  }

  // Actions
  prevStep() {
    this.$ngRedux.dispatch(DemandeActions.updateIncidentDetecte(this.data, true));
  }
  nextStep(continuerPrtv) {
    //On vérifie si on cotinue en prtv ou pas
    this.data.continuerPrtv = continuerPrtv;
    this.$ngRedux.dispatch(DemandeActions.updateIncidentDetecte(this.data));
  }
}



// WEBPACK FOOTER //
// ./src/modules/accueil/components/incident-detecte/incident-detecte.component.js